import React from 'react';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import { calculateBarLengthPercent, formatCurrency, getBarChartYLabels } from 'utils';

import classes from './demographicChart.module.css';

const ReactTooltip = dynamic(() => import('react-tooltip'), { ssr: false });

const propTypes = {
  xLabels: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.arrayOf(PropTypes.number),
  yFormatter: PropTypes.func,
  isYStartsZero: PropTypes.bool,
};

const defaultProps = {
  xLabels: [],
  values: [],
  yFormatter: null,
  isYStartsZero: false,
};

const DemographicChart = ({ xLabels, values, yFormatter, isYStartsZero }) => {
  const yLabels = getBarChartYLabels(values, 'desc', 5, isYStartsZero);

  return (
    <div className={classes['salary-demographic-chart']}>
      <div className={classNames('mt-4 mb-0 position-relative', classes['bar-chart-container'])}>
        <div className={classNames('d-flex flex-column', classes['y-labels'])}>
          {yLabels.map((yLabel, idx) => (
            <div
              key={yLabel + idx}
              className={classNames(
                'lightTextStyle2 d-flex justify-content-end align-items-center',
                classes['y-label']
              )}
            >
              <span>{yFormatter ? yFormatter(yLabel) : formatCurrency(yLabel)}</span>
              <span className={classes['grid-line']} />
            </div>
          ))}
        </div>

        <div
          className={classNames(
            'd-flex justify-content-between justify-content-sm-around align-items-end w-100 ml-0 ml-md-5',
            classes['x-labels']
          )}
        >
          {xLabels.map((xLabel, idx) => (
            <div key={xLabel + idx} className={classNames('d-flex', classes['x-label'])}>
              <div className={classNames('lightTextStyle2', classes['label'])}>{xLabel}</div>
              <div className={classes['bars']}>
                <div
                  className={classes['bar']}
                  data-place="top"
                  data-tip={`<strong>${formatCurrency(values[idx])}</strong>`}
                  style={{
                    height: `${calculateBarLengthPercent(yLabels, values[idx])}%`,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        <ReactTooltip html />
      </div>
    </div>
  );
};

DemographicChart.propTypes = propTypes;
DemographicChart.defaultProps = defaultProps;

export default DemographicChart;
